
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'

@Options({
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    mounted () {
      const _this = this;
      this.$common.pageLoaded()
      let homeShareData = JSON.parse(JSON.stringify(this.shareData))
      homeShareData.link = window.location.href
      this.$common.onshare(homeShareData)
      this.$common.track('load', '进入首页')

      if (COVERAPP.Attribute.isWeixin() && this.$common.getUrl('code')) {
        this.$common.getUser((res) => {
          const userinfo = JSON.parse(JSON.stringify(res));
          _this.SET_USERINFO(userinfo);
        });
      }
    },
    methods: {
      ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
      handleStart(isTeam) {
        if (!COVERAPP.Attribute.isApp() && !COVERAPP.Attribute.isWeixin()) {
          this.SET_DIALOGDATA({
            text: '参加该活动需在封面新闻APP中进行',
            btns: [
              {
                text: '取消',
                className : 'cancel-btn'
              },
              {
                text: '确定',
                className : 'download-btn'
              }
            ]
          })
          return;
        }

        if (this.activityData.isApp && !COVERAPP.Attribute.isApp()) {
          this.SET_DIALOGDATA({
            text: '参加该活动需在封面新闻APP中进行',
            btns: [
              {
                text: '取消',
                className : 'cancel-btn'
              },
              {
                text: '确定',
                className : 'download-btn'
              }
            ]
          })
          return;
        }

        if (isTeam && !this.activityData.templateConfig.isOpenTeam) {
          this.SET_DIALOGDATA({
            text: '尚未开启团体挑战赛',
            btns: [
              {
                text: '关闭',
                className : 'cancel-btn'
              },
            ]
          })
          return;
        }

        const _this = this;
        this.$common.getUser((res) => {
          const userinfo = JSON.parse(JSON.stringify(res));
          _this.SET_USERINFO(userinfo);
          if (!userinfo || !userinfo.token) {
            if (COVERAPP.Attribute.isApp()) {
              COVERAPP.Method.OpenLogin({
                callback(res) {
                  if (res && res.token) {
                    _this.queryAnswer(isTeam);
                  }
                }
              });
              return;
            }

            alert('请先登录~');
            return;
          }
          
          _this.queryAnswer(isTeam);
        });
      },
      async queryAnswer(isTeam) {
        const activityData = this.activityData;
        let loadtime = setTimeout(() => {
          this.$common.pageLoading();
        }, 1500);
        const res = await this.$request("/answer/user/count", {
          aid: this.aid,
          isTeam,
          userinfo: this.userInfo,
          match: 1,
        }, 'post').catch(err => {
          this.SET_DIALOGDATA({
            text: (err.errmsg || `(${ err.errmsg })`) ||  "网络错误~",
            btns: [
              {
                text: '确定',
                className : 'cancel-btn'
              },
            ]
          })
        });
        this.$common.pageLoaded();
        clearTimeout(loadtime);
        const status = res.status;
        if (status === 0) {
          // 去团队赛
          if (isTeam) {
            window.location.href = `/ptpanswer/#/answer?id=${ this.aid }&match=2`;
            return;
          }

          if (activityData.isOpenName || activityData.isOpenPhone) {
            window.location.href = `/contestanswers/#/select?id=${ this.aid }`;
            return;
          }

          window.location.href = `/ptpanswer/#/answer?id=${ this.aid }&match=1`;
          return;
        }

        let statusText = {
          '2010': '答题未开始',
          '2011': '答题已结束',
          '2012': '已超过答题总数',
          '2013': '亲，您今日答题次数已用完，明天再来答题吧。',
          '2014': '已完成答题',
          '2015': '当日已完成团队赛答题'
        }
        
        this.SET_DIALOGDATA({
          text: statusText[status] ||  "网络错误~",
          btns: [
            {
              text: '确定',
              className : 'cancel-btn'
            },
          ]
        })
      },
      onRank() {
        window.location.href = `/ptpanswer/#/rank?id=${ this.aid }`;
      },
      handlePrizeRecord() {
        const aid = this.aid;
        if (!COVERAPP.Attribute.isApp() && !COVERAPP.Attribute.isWeixin()) {
          this.SET_DIALOGDATA({
            text: '参加该活动需在封面新闻APP中进行',
            btns: [
              {
                text: '取消',
                className : 'cancel-btn'
              },
              {
                text: '确定',
                className : 'download-btn'
              }
            ]
          })
          return;
        }

        if (this.activityData.isApp && !COVERAPP.Attribute.isApp()) {
          this.SET_DIALOGDATA({
            text: '参加该活动需在封面新闻APP中进行',
            btns: [
              {
                text: '取消',
                className : 'cancel-btn'
              },
              {
                text: '确定',
                className : 'download-btn'
              }
            ]
          })
          return;
        }

        this.$common.getUser((res) => {
          const userinfo = JSON.parse(JSON.stringify(res));
          if (!userinfo || !userinfo.token) {
            if (COVERAPP.Attribute.isApp()) {
              COVERAPP.Method.OpenLogin({
                callback(res) {
                  if (res && res.token) {
                    window.location.href = `/prize/#/?id=${ aid }`;
                  }
                }
              });
              return;
            }

            alert('请先登录~');
            return;
          }
          
          window.location.href = `/prize/#/?id=${ aid }`;
        });
      },
    }
})
export default class Home extends Vue {}
